
























import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import _ from "lodash";

@Component
export default class TimeInput extends Vue {
  @Prop() label?: string;
  @Prop({ default: false }) required?: boolean;
  @PropSync("from") fromInternal?: string | null;
  @PropSync("to") toInternal?: string | null;
  @Prop({ default: false }) singleValue?: boolean;

  get rules() {
    return this.required || !!this.selectFrom !== !!this.selectTo
      ? [this.requiredRule]
      : [];
  }
  requiredRule(v: any) {
    return v ? true : this.$t("Validation.Required");
  }

  timeOptions = Array.from(
    Array(48),
    (v, k) =>
      `${_.padStart(Math.floor(k / 2).toString(), 2, "0")}:${
        k % 2 ? "30" : "00"
      }`
  );

  get selectFrom(): string | null {
    return this.fromInternal?.substring(0, 5) ?? null;
  }
  set selectFrom(val: string | null) {
    this.fromInternal = val != null ? val + ":00" : null;
  }
  get selectTo(): string | null {
    return this.toInternal?.substring(0, 5) ?? null;
  }
  set selectTo(val: string | null) {
    this.toInternal = val != null ? val + ":00" : null;
  }
}
